import { Modal, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useHttp } from "../../hooks/useHttp";
import { Pipeline } from "../../models/tasks";
import MouseIcon from "@mui/icons-material/Mouse";

export interface OrganVisualizationInterface {
  task: any;
  organImages: any;
  pretty_name: any;
  setScene: any;
  scene: any;
  nodulesFound: boolean;
}

export const OrganVisualization = ({
  task,
  organImages,
  pretty_name,
  setScene,
  scene,
  nodulesFound,
}: OrganVisualizationInterface) => {
  const [organsCache, setOrgansCache] = useState<any>({});
  const { trigger: downloadSceneRequest } = useHttp<any>(
    task.pipeline === Pipeline.LUNGS_REPORT ? "/lungsTasks/scene" : "/nodulesTasks/scene",
    {},
    true,
  );
  return (
    <div className="taskComponent-visualization">
      <div className="taskComponent-title">
        <p>Mask Visualization</p>
      </div>
      <div className="taskComponent-organVisualizations">
        {task.completed && nodulesFound && (
          <div className="taskComponent-organVisualizations-grid">
            {Object.keys(organImages).map((organ) => {
              return (
                <div key={organ} className="taskComponent-organVisualizations-vis" onClick={() => setScene(organ)}>
                  <img src={organImages[organ]} alt={organ} />
                  <p>{typeof pretty_name === "function" ? pretty_name(organ) : pretty_name[organ]}</p>
                </div>
              );
            })}
          </div>
        )}
        {!nodulesFound && task.completed && <h1>No nodules found on image</h1>}
        {!task.completed && <h1>Visualization will be available once the task is completed.</h1>}
      </div>

      <Modal
        open={scene !== null}
        onClose={() => setScene(null)}
        className="taskComponent-organVisualizations-modal"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "90vw",
            height: "90vh",
            bgcolor: "background.paper",
          }}
        >
          <h1 className="taskComponent-organVisualizations-modal-title">Mask for: {pretty_name[scene ? scene : ""]}</h1>
          <iframe
            src={
              process.env.REACT_APP_API_URL +
              `/${task.pipeline === Pipeline.LUNGS_REPORT ? "lungsTasks" : "nodulesTasks"}/scene?taskId=${task.id}&scene=${scene}`
            }
            title="Fullscreen Mask Visualization"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
          <div className="taskComponent-organVisualizations-modal-legend">
            <div className="taskComponent-organVisualizations-modal-legend-item">
              <div className="taskComponent-organVisualizations-modal-legend-item-title">Rotate:</div>
              <MouseIcon />
            </div>
            <div className="taskComponent-organVisualizations-modal-legend-item">
              <div className="taskComponent-organVisualizations-modal-legend-item-title">Zoom:</div>
              Scroll
            </div>
            <div className="taskComponent-organVisualizations-modal-legend-item">
              <div className="taskComponent-organVisualizations-modal-legend-item-title">Move:</div>
              Shift + <MouseIcon />
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
